import React, { Component, Fragment } from 'react'
import { Mutation } from 'react-apollo'

import { USER_BRANCH_QUERY } from '../../queries'
import { CREATE_USER } from '../../mutations'

import SearchInput from '../../components/SearchInput/'
import FormPopup from '../../components/FormPopup/'
import Branch from '../../components/Branch/'

import helpers from '../../helpers'

import { InfoContainer, CompanyInfo, PageTitleContainer, PageTitle, NewButton, SearchContainer } from './styles'

class Members extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popupActive: false
    }
  }

  branchOptions() {
    return this.props.branches.map(branch => {
      let value = this.props.branches.length < 2 ? true : false
      value = this.props.branch.id === branch.id ? true : value
      return { label: branch.name, name: branch.id, value, type: 'checkbox' }
    })
  }

  nrOfUsers() {
    const { branches } = this.props
    let i = 0
    let nr = 0

    for (i = 0; i < branches.length; i++) {
      nr = nr + branches[i].users.length
    }

    return nr
  }

  openPopup() {
    if (!this.state.popupActive) {
      this.setState({ popupActive: true })
      document.body.classList.add('popup-active')
      document.documentElement.classList.add('popup-active')
    }
  }

  closePopup() {
    this.setState({ popupActive: false })
    document.body.classList.remove('popup-active')
    document.documentElement.classList.remove('popup-active')
  }



  onSearch(e) {
    let query = e.target.value.trim().toLowerCase()
    let queryLength = e.target.value.length
    this.setState({ query: e.target.value })
    this.props.branches.map(branch => {
      let result = branch.users.filter(user => {
        let firstName = user.firstName.toLowerCase().slice(0, queryLength)
        let lastName = user.lastName.toLowerCase().slice(0, queryLength)
        let email = user.email.toLowerCase().slice(0, queryLength)
        let fullName =
          user.firstName.toLowerCase().slice(0, queryLength) +
          ' ' +
          (user.insertion !== null && user.insertion !== undefined && user.insertion !== ''
            ? user.insertion.toLowerCase().slice(0, queryLength) + ' '
            : '') +
          user.lastName.toLowerCase().slice(0, queryLength)
        return (
          firstName === query ||
          lastName === query ||
          email === query ||
          fullName.indexOf(query) !== -1
        )
      })
      branch.filteredUsers = result
      return null
    })
  }

  render() {
    const branches = this.branchOptions()
    const insertions = helpers.getInsertions()
    let genderOptions = [{ value: 'MALE', label: 'Man' }, { value: 'FEMALE', label: 'Vrouw' }]
    let formFields = [
      { name: 'gender', label: 'Geslacht', value: '', type: 'select', options: genderOptions },
      { name: 'firstName', label: 'Voornaam*', value: '', type: 'text', required: 'required' },
      { name: 'insertion', label: 'Tussenvoegsel', value: '', type: 'select', options: insertions },
      { name: 'lastName', label: 'Achternaam*', value: '', type: 'text', required: 'required' },
      { name: 'email', label: 'E-mailadres*', value: '', type: 'email', required: 'required' },
      { name: 'phone', label: 'Telefoonnummer*', value: '', type: 'tel', required: 'required' },
      { name: 'altPhone', label: 'Alternatief telefoonnummer', value: '', type: 'tel' }
    ]

    formFields = [{ type: 'title', name: 'Filialen:' }].concat(branches.concat(formFields))

    const { permissions, role } = this.props
    const addUser = permissions.includes('ADD_USER') || role === 'MANAGER'
    const editUser = permissions.includes('EDIT_USER') || role === 'MANAGER'
    const deleteUser = permissions.includes('DELETE_USER') || role === 'MANAGER'

    return (
      <Fragment>
        <PageTitleContainer>
          <PageTitle>Medewerkers</PageTitle>
          {addUser ? (
            <NewButton onClick={this.openPopup.bind(this)}>
              <span>Nieuw</span>
              <span>Nieuwe medewerker toevoegen</span>
            </NewButton>
          ) : null}
        </PageTitleContainer>

        <InfoContainer full>
          <CompanyInfo>
            <div>{this.props.company}</div>
            <div>{this.nrOfUsers()} medewerkers</div>
          </CompanyInfo>
          <SearchContainer>
            <SearchInput placeholder="Zoeken" onSearch={this.onSearch.bind(this)} />
          </SearchContainer>
        </InfoContainer>

        {this.props.branches.map(branch => {
          return (
            <Branch
              editUser={editUser}
              deleteUser={deleteUser}
              data={branch}
              key={branch.id}
              currentUser={this.props.currentUser}
            />
          )
        })}

        {this.state.popupActive ? (
          <Mutation
            mutation={CREATE_USER}
            update={(store, { data: { createUser } }) => {
              const data = store.readQuery({ query: USER_BRANCH_QUERY })
              createUser.branches.forEach((branch) => {
                let branchIndex = data.self.branches.findIndex(x => x.id === branch.id)
                data.self.branches[branchIndex].users.push(createUser)
              })
              
              store.writeQuery({
                query: USER_BRANCH_QUERY,
                data
              })
            }}
          >
            {(createUser, { data, loading, error }) => {
              return (
                <Fragment>
                  {addUser ? (
                    <FormPopup
                      closePopup={this.closePopup.bind(this)}
                      onSubmitForm={createUser}
                      data={data}
                      loading={loading}
                      error={error}
                      fields={formFields}
                      clearForm
                      title="Medewerker toevoegen"
                      errorMessage="Foutieve of lege velden, controleer formulier"
                      succesMessage="Medewerker toegevoegd"
                    />
                  ) : null}
                </Fragment>
              )
            }}
          </Mutation>
        ) : null}
      </Fragment>
    )
  }
}

export default Members



// WEBPACK FOOTER //
// ./src/containers/Members/index.js